import "./Skills.css";
import Aos from "aos";
import "aos/dist/aos.css"
import { useEffect } from "react";

function Skills() {
  useEffect(() => {
    Aos.init({duration:1000})
  }, [])

  const skills = [
    {
      icon: "fas fa-brain",
      title: "AI & Machine Learning",
      content: "PyTorch | TensorFlow | Scikit-learn | Pandas | NumPy | OpenCV | NLTK | Groq | Mistral | FER",
    },
    {
      icon: "fas fa-server",
      title: "Backend & Databases",
      content: "Python | Golang | Java | FastAPI | Flask | Django | SQL",
    },
    {
      icon: "fas fa-tools",
      title: "Developer Tools & Platforms",
      content: "Git | GitHub | Docker | Google Cloud Platform | VS Code | Linux",
    },
    {
      icon: "fas fa-users",
      title: "Leadership & Soft Skills",
      content: "Project Management | Team Leadership | Public Speaking | Mentoring",
    }
  ];

  return (
    <div id="skills" className="container-fluid">
      <h2 className="skill-title topic-head">My Expertise</h2>
      <div className="row">
        {skills.map((skill, index) => (
          <div className="col-lg-6" key={index}>
            <div className="skill-card" data-aos="fade-up" data-aos-once="true">
              <div>
                <i className={skill.icon}></i>
              </div>
              <div className="skill-card-title">{skill.title}</div>
              <div className="skill-card-content">
                {skill.content}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
